import { Card, message, Skeleton } from 'antd'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { makeRequest } from 'api'

const ClassRequest = () => {
  const { id, status } = useParams()
  const [loaded, setLoaded] = useState(true)
  const [success, setSuccess] = useState(true)

  useEffect(() => {
    setLoaded(true)
    if (id && status) {
      if (status === 'accepted') {
        makeRequest(
          'patch',
          `/component/program/teacher-acceptance/${id}/Accepted`,
        )
          .then(() => {
            message.success('Teaching request accepted successfully')
            setLoaded(false)
            setSuccess(true)
          })
          .catch((err) => {
            message.error(
              err?.response?.data?.message || 'Something went wrong',
            )
            setLoaded(false)
            setSuccess(false)
          })
      } else if (status === 'rejected') {
        makeRequest(
          'patch',
          `/component/program/teacher-acceptance/${id}/Rejected`,
        )
          .then(() => {
            message.success('Teaching request rejected successfully')
            setLoaded(false)
            setSuccess(true)
          })
          .catch((err) => {
            message.error(
              err?.response?.data?.message || 'Something went wrong',
            )
            setLoaded(false)
            setSuccess(false)
          })
      } else {
        message.error('Link is not valid')
        setLoaded(false)
        setSuccess(false)
      }
    }
    // eslint-disable-next-line
  }, [])

  return (
    <div className="t-p-6">
      <Skeleton loading={loaded} active paragraph={{ rows: 18 }}>
        <Card
          className="header-solid t-p-2 t-m-4"
          bordered={false}
          title={[
            <>
              <h6 className="mb-0">
                {success ? (
                  <div>
                    You have successfully {status} the invitation.{' '}
                    <a
                      href={`${window.location.origin}/programs/${id}`}
                      className="t-font-bold t-text-secondary-100"
                      rel="noreferrer"
                    >
                      Click here
                    </a>{' '}
                    to go to the program
                  </div>
                ) : (
                  'Something went Wrong'
                )}
              </h6>
            </>,
          ]}
        />
      </Skeleton>
    </div>
  )
}

export { ClassRequest }
